// @ts-check
// Cấu hình kết nối.
//
// Chia làm 2 tầng, cố ý:
//   - Cấu hình MÔI TRƯỜNG (Entra app, site SharePoint) → đọc từ .env qua
//     import.meta.env, để local/staging/prod trỏ chỗ khác nhau mà không sửa code.
//   - Cấu hình NGHIỆP VỤ (tên list, positions, target KPI, admins) → nằm thẳng
//     ở đây: nó giống nhau ở mọi môi trường và cần review khi thay đổi.
//
// Không có secret ở cả 2 tầng — xem .env và docs/ENTRA-SETUP.md.

// `|| {}`: file này vẫn import được ngoài Vite (node --test), khi đó
// import.meta.env là undefined.
const env = import.meta.env || {};

/** Trả về giá trị env nếu có, ngược lại fallback. Chuỗi rỗng coi như không có. */
const fromEnv = (/** @type {string|undefined} */ value, /** @type {string} */ fallback) =>
  value === undefined || value === "" ? fallback : value;

export const CONFIG = {
  // --- Tầng môi trường (.env) ---
  clientId: fromEnv(env.VITE_CLIENT_ID, "YOUR_CLIENT_ID"),
  tenantId: fromEnv(env.VITE_TENANT_ID, "YOUR_TENANT_ID"),
  siteHost: fromEnv(env.VITE_SITE_HOST, "eastgatesoftware.sharepoint.com"),
  sitePath: fromEnv(env.VITE_SITE_PATH, "/sites/ORGHRAdmin"),

  // --- Tầng nghiệp vụ ---
  funnelList: "Recruitment Funnel Weekly",
  kpiList: "TA KPI Achievements",
  // Dòng data của những người này bị loại khỏi mọi thống kê (data test,
  // không phải nhân sự TA).
  excludeRecruiters: ["Hong Bui"],
  // Target phỏng vấn mỗi tuần cho 1 vị trí đang tuyển (section Open Positions).
  interviewWeeklyTarget: 5,
  // Email được thấy màn Admin (xem/xóa mọi entry).
  admins: ["hong.bui@eastgate-software.com"],
  // Ready to Offer — TA log trực tiếp trên platform (list SharePoint bên
  // dưới), không query Azure Board nữa (board không có lịch sử, ticket đổi
  // cột là mất dấu). KPI: luôn có rtoTargetMin–rtoTargetMax ứng viên đang
  // chờ offer cho mỗi tech stack active.
  rtoList: "TA Ready to Offer",
  rtoTargetMin: 4,
  rtoTargetMax: 5,
  // Map title trên board → Position (khi cách viết khác tên position).
  stackAliases: {
    "Backend Web": ["BE Web", "BE", "Backend"],
    "Frontend Web": ["FE Web", "FE", "Frontend"],
    "UI/UX": ["UIUX", "UI-UX"],
    "C#": [".NET"],
    "Mobile": ["React Native", "Flutter", "iOS", "Android"],
  },
  // List settings dùng chung (Admin chọn active stacks...).
  settingsList: "TA Settings",
  // Các vị trí đang tuyển — khớp choice của cột Position trong list.
  positions: ["Java", "Frontend Web", "Backend Web", "AI", "DevOps", "BA", "QA",
    "PM", "UI/UX", "GET", "KAM", "MKT", "HR", "Comtor", "Mobile", "C#"],

  // Demo mode: VITE_DEMO=true (ép trong .env.local) hoặc chưa cấu hình clientId.
  isDemo() {
    return env.VITE_DEMO === "true" || this.clientId === "YOUR_CLIENT_ID";
  },
};
